import React from "react"
import PropTypes from "prop-types"
import MessageBox from "@/components/MessageBox"
import { withApi } from "@tencent/react-aio"
import * as ActionTypes from "@/stores/sale/actions"
import _ from "lodash"
import Dialog from "@/components/Dialog"
import { FormGroup, Input, RadioGroup, Select } from "@tencent/spaui"
import { enumMessages } from "@/utils/MessageUtils"
import Money from "@/components/Money"
import { rendeFirstChargeAmt } from "@/utils/ColumnRender"

const reviewPass = "REVIEW_STATUS_PASSED"
const reviewReject = "REVIEW_STATUS_REJECTED"
const style = { marginTop: "8px", marginBottom: "8px" }
class PaymentReviewModal extends React.Component {
  static propTypes = {
    orderInfo: PropTypes.object.isRequired,
    version: PropTypes.number.isRequired,
    onSubmit: PropTypes.func,
  }

  state = {}

  render() {
    const { orderInfo } = this.props
    const { lead = {} } = orderInfo
    const { reviewStatus, rejectReason, comments, error } = this.state
    const config = this.getMessages("ReviewStatus")

    // 拒绝理由
    const rejectReasonConfig = this.getMessagesForSelect("ReviewRejectReason")

    return (
      <Dialog className="PaymentReviewModal" title="到款确认" style={{ width: 640 }} {...this.props} onSubmit={this.onSubmit}>
        <React.Fragment>
          <p>
            <label>线索ID：</label>
            {orderInfo.leadId}
          </p>
          <p>
            <label>公司名称：</label>
            {lead.company.companyName}
          </p>
          <p>
            <label>汇款账户名称：</label>
            {orderInfo.remittanceAccountName}
          </p>
          <p>
            <label>首次到款金额：</label>
            <Money value={orderInfo.firstPaymentAmount} />
          </p>
          <p>
            <label>服务费：</label>
            <Money value={orderInfo.serviceFee} />
          </p>
          <p>
            <label>账户名称：</label>
            {
              lead.enterpriseName ? <React.Fragment>
                {lead.enterpriseName} {lead.customerId && `(ID：${lead.customerId})`}
              </React.Fragment> : "-"
            }
          </p>
          <p>
            <label>实际首充金额：</label>
            {lead.customerId ? rendeFirstChargeAmt(orderInfo.firstChargeAmt) : "-"}
          </p>
          <p>
            <label>首次充值时间：</label>
            {lead.customerId && orderInfo.firstChargeTime ? orderInfo.firstChargeTime : "-"}
          </p>
          <p style={style}>
            <label>确认已经到款？</label>
          </p>
        </React.Fragment>

        <div className="RadioGroup">
          <h4>审核结果：</h4>
          <RadioGroup style={style} data={config} value={reviewStatus} onChange={this.handleChange} />
        </div>

        {reviewStatus === reviewReject && (
          <React.Fragment>
            <FormGroup className={"required with-select"}>
              <label className="required">拒绝理由：</label>
              <Select clear={true} className="OrderStatusSelect" data={rejectReasonConfig} value={rejectReason} onChange={this.handleReasonChange} />
            </FormGroup>
            <FormGroup className={"required with-select"}>
              <label className="required">备注：</label>
              <textarea rows={4} cols={30} className="spaui-input" value={comments} onChange={this.handleCommentsChange} placeholder={"驳回原因/备注"} />
            </FormGroup>
          </React.Fragment>
        )}

        {error && (
          <p className={"has-error"}>
            <span className={"error-message"}>发生错误：{error.message || "服务器错误"}</span>
          </p>
        )}
      </Dialog>
    )
  }

  getMessages = (key) => {
    return _.compact(
      _.map(enumMessages(key), (message) => {
        return {
          value: message.value,
          children: message.message,
        }
      })
    )
  }

  getMessagesForSelect = (key) => {
    return _.compact(
      _.map(enumMessages(key), (message) => {
        return {
          value: message.value,
          label: message.message,
        }
      })
    )
  }

  handleChange = (event, value) => {
    this.setState({
      reviewStatus: value,
      error: null,
    })
  }

  handleReasonChange = (event, value) => {
    this.setState({
      rejectReason: value,
    })
  }

  handleCommentsChange = (event) => {
    this.setState({
      comments: event.target.value,
    })
  }

  onSubmit = () => {
    const { webApi } = this.props
    const { orderInfo: order } = this.props
    const { reviewStatus, rejectReason, comments } = this.state

    if (!reviewStatus) {
      this.setState({
        error: {
          message: "审核状态必填",
        },
      })
      return
    }

    //数据校验
    if (reviewStatus && reviewStatus === reviewReject) {
      if (!rejectReason) {
        this.setState({
          error: {
            message: "拒绝理由必填",
          },
        })
        return
      }

      if (!comments) {
        this.setState({
          error: {
            message: "备注必填",
          },
        })
        return
      }
    }

    const params = {
      orderId: order.orderId,
      leadId: order.leadId,
      reviewStatus: reviewStatus,
      rejectReason: rejectReason,
      comments: comments,
      version: this.props.version,
    }

    webApi
      .reviewOrderPayment()
      .dispatchJson(ActionTypes.REVIEW_ORDER_PAYMENT, {
        data: params,
      })
      .then(
        (resp) => {
          this.context.success("审核结果提交成功")
          this.props.onSubmit()
          this.props.refreshTable()
        },
        (error) => {
          this.context.error("审核结果提交失败", error.message)
          this.props.onSubmit()
        }
      )
  }
}

export default withApi(PaymentReviewModal)

PaymentReviewModal.contextType = MessageBox
